import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import { styled } from '@mui/material';
import { TPopupDefaultActions } from '../../../../../../../../shared/components/popup/services/popup.service.ts';
import { Content } from './content.popup.tsx';
import { bakery2bClientsState } from '../../../../../states/bakery2bClients.state.ts';

export class ConnectedCustomersPopup extends Popup<IConnectedCustomersPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const formMethods = useForm<IForm>({
        defaultValues: {
          customerId: null,
        },
      });
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 528, minWidth: 528, width: '100%' },
          '& > div > div > div': { padding: 20 },
        }));
      }, []);
      useEffect(() => {
        stream.actionListener('open').subscribe(() => {
          bakery2bClientsState.pub.customerListConnectedWithBakery2BClient();
        });
      }, []);

      return (
        <FormProvider {...formMethods}>
          <form noValidate>
            <SWrapper stream={stream} popupTitle={t('settings.connected_customers')}>
              <Content />
            </SWrapper>
          </form>
        </FormProvider>
      );
    };
  }
}

interface IConnectedCustomersPopup {
  action: TPopupDefaultActions;
}
export interface IForm {
  customerId: string | null;
}
